import { render } from "./PropertySystem.vue?vue&type=template&id=388a943a&scoped=true"
import script from "./PropertySystem.vue?vue&type=script&lang=js"
export * from "./PropertySystem.vue?vue&type=script&lang=js"

import "./PropertySystem.vue?vue&type=style&index=0&id=388a943a&scoped=true&lang=css"

import exportComponent from "E:\\changjuCode\\official-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-388a943a"]])

export default __exports__